import React, {useState} from "react";

const HeaderLink = ({txt, children}) => {
    const [isShown, setIsShown] = useState(false);
    const visibleClass = isShown ? " visible" : ""
    const cssClass = "tile account-links-popup" + visibleClass;

    return (
        <div className="clickable-text"
           onMouseEnter={() => setIsShown(true)}
           onMouseLeave={() => setIsShown(false)}>
            <p>{txt}</p>
            <div
                className={cssClass}>
                {children}
            </div>
        </div>
    )
}

export default HeaderLink;
